import { Injectable } from '@angular/core'
import { Config } from '@spartacus/core'
import { MbBaseSiteCountry } from '../models'

@Injectable({
  providedIn: 'root',
  useExisting: Config,
})
export abstract class StoreContextConfig extends Config {
  mbcomstore?: {
    sites?: MbBaseSiteCountry[];
  }
}
